const o = {
  connect: () => {
  },
  getRequestParams: ({ ton: e }) => (console.log("options", e), {}),
  signMessage: () => {
  }
};
export {
  o as default
};
